import moment from 'moment'
import { defaultValue } from "root/tools.js"

export default {
	// Basis Informationen des Model
	model: {
		id: 0,
		firstname: '',
		lastname: '',
		customer_id: 0,
		name: '',

			// Daten die in relations wichtig sind
		from: null,
		until: null,

		forced: true
	},

	clear () {
		this.model.id = 0
		this.model.firstname = ''
		this.model.lastname = ''
		this.model.name = ''

		this.graves = []
		this.deceaseds = []
		this.addresses = []
		this.contacts = []

			// Daten die in relations wichtig sind
		this.model.from = moment(Date.now()).format('YYYY-MM-DD')
		this.model.until = moment(moment(Date.now()).add(25, 'years')).format('YYYY-MM-DD')

		this.model.forced = true
	},

	clearModel () {
		this.model.id = 0
		this.model.firstname = ""
		this.model.lastname = ""
		this.model.birthname = ""
		this.model.birthplace = ""
		this.model.birthday = null
		this.model.denomination_id = 0
		this.model.gender = 0

		this.graves = []
		this.deceaseds = []
		this.addresses = []
		this.contacts = []

		this.model.from = null
		this.model.until = null
	},

	name: 'customers',

	// Die Spalten der Tabelle
  cols: [
		{name: 'Vorname', json: 'firstname', type: 'text'},
		{name: 'Nachname', json: 'lastname', type: 'text'}
  ],

	relations: [
		'graves',
		'deceaseds',
		'zips',
		'contact_types',
		'address_types',
		'denominations'
	],

	copy (aModel) {
		this.model.customer_id = aModel.customer_id
		this.model.name = aModel.customer_id + ': ' + aModel.lastname + ', ' + aModel.firstname

			// Daten die in relations wichtig sind
		this.model.from = aModel.from
		this.model.until = aModel.until

		this.model.forced = true

		console.log(aModel)
		console.log(this.model)

		this.model.id = aModel.id
		this.model.firstname = aModel.firstname
		this.model.lastname = aModel.lastname
		this.model.birthname = aModel.birthname
		this.model.birthplace = aModel.birthplace
		this.model.birthday = aModel.birthday
		this.model.denomination_id = aModel.denomination_id
		this.model.gender = aModel.gender
	},

	validate () {
		this.model.from = moment(this.model.from, 'YYYY-MM-DD').toISOString()
		this.model.until = moment(this.model.until, 'YYYY-MM-DD').toISOString()

		this.model.forced = true

		return true
	},

	validateModel () {
  		if (defaultValue(this.model.firstname, "").trim() === "" || defaultValue(this.model.lastname, "").trim() === "") {
  			return false
		}

		return true
	},

	// Beziehungen zu anderen Models
	graves: [],
	deceaseds: [],
	addresses: [],
	contacts: []
}



// WEBPACK FOOTER //
// ./src/models/customers.js